import React, { useContext } from "react";
import { Grid, Box, Typography } from "@material-ui/core";
import { Formik, Form, Field } from "formik";
import lodash from "lodash";
import { navigate } from "@reach/router";

import CustomInput from "../components/Custom/CustomInput";
import PrimaryButtton from "../components/Custom/Button/PrimaryButtton";
import { firebaseSignin, firebaseAuthUser } from "../firebase/auth";
import AuthLayout from "../components/Layout/AuthLayout";
import { AuthStoreContext } from "../contexts";
import { firebaseFetchUserProfile } from "../firebase/user";

export default function SigninPage() {
  /**
  |--------------------------------------------------
  | Contexts
  |--------------------------------------------------
  */
  const authStore = useContext(AuthStoreContext);
  /**
  |--------------------------------------------------
  | Form Setup
  |--------------------------------------------------
  */
  const initialValues = {
    email: "",
    password: "",
  };

  /**
  |--------------------------------------------------
  | Sign in
  |--------------------------------------------------
  */
  async function onSignin(values, formik) {
    try {
      formik.setSubmitting(true);
      await firebaseSignin(values.email, values.password);
      const user = await firebaseAuthUser();
      const userProfile = await firebaseFetchUserProfile(user.uid);
      authStore.setAuthUser(user);
      authStore.setAuthUserProfile(userProfile);
      formik.setSubmitting(false);

      const params = new URLSearchParams(window.location.search);
      const redirect = params.get("redirect");
      if (redirect !== null) {
        navigate(`/${redirect}`);
      } else {
        if (authStore.authUserProfile.dealer) {
          navigate(`/${authStore.authUserProfile.dealer}`);
        } else {
          navigate(`/`);
        }
      }
    } catch (error) {
      formik.setSubmitting(false);
      if (error.code === "auth/invalid-email") {
        formik.setFieldError(
          "email",
          `The email address that you've entered doesn't match any account.`
        );
      }

      if (error.code === "auth/user-not-found") {
        formik.setFieldError("email", "User not found.");
      }

      if (error.code === "auth/wrong-password") {
        formik.setFieldError(
          "password",
          `The password that you've entered is incorrect.`
        );
      }

      console.error(error);
    }
  }

  return (
    <AuthLayout>
      <Grid
        container
        alignItems="center"
        justify="center"
        style={{ height: "100vh" }}
      >
        <Grid item xs lg={3}>
          <Formik initialValues={initialValues} onSubmit={onSignin}>
            {(props) => (
              <Form>
                <Box bgcolor="grey.800" p={6} borderRadius="borderRadius">
                  <Grid container spacing={6}>
                    {/* SIGN IN HEADER */}
                    <Grid item xs={12}>
                      <Typography align="center" variant="h5">
                        IOT Dashboard
                      </Typography>
                    </Grid>
                    {/* SIGN IN HEADER */}

                    <Grid item xs={12}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} container>
                          <Grid item xs={12}>
                            <Field name="email">
                              {({ field, meta }) => (
                                <CustomInput
                                  fullWidth
                                  label="Email"
                                  fieldProps={{ ...field }}
                                  error={
                                    meta.touched && !lodash.isEmpty(meta.error)
                                  }
                                  errorHelp={meta.error}
                                />
                              )}
                            </Field>
                          </Grid>
                          <Grid item xs={12}>
                            <Field name="password">
                              {({ field, meta }) => (
                                <CustomInput
                                  fullWidth
                                  label="Password"
                                  type="password"
                                  fieldProps={{ ...field }}
                                  error={
                                    meta.touched && !lodash.isEmpty(meta.error)
                                  }
                                  errorHelp={meta.error}
                                />
                              )}
                            </Field>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <PrimaryButtton
                            fullWidth
                            type="submit"
                            loading={props.isSubmitting}
                          >
                            Sign in
                          </PrimaryButtton>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </Grid>
      </Grid>
    </AuthLayout>
  );
}
